import {MatDialogConfig} from '@angular/material/dialog';


export function createDefaultDialogConfig() {

  const dialogConfig = new MatDialogConfig();

  dialogConfig.autoFocus = true;
  dialogConfig.disableClose = true;
  dialogConfig.panelClass= 'modal-panel';
  dialogConfig.backdropClass = 'backdrop-modal-panel';
  dialogConfig.enterAnimationDuration = "0";

  return dialogConfig;
}
